import {Avatar, CardHeader, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {TransformedOccurrence} from '../../../../../utils/data/occurrences';
import {OccurrenceStatus} from './occurrences-status';
import {translations} from '../../../../../i18n/translations';
import {CardCollapse} from '../../../../../components/shared/card-collapse';
import moment from 'moment';
import './handle-card.scss';

export const HandleOccurrenceCard = ({
  data,
  isDailyCareApp = false,
  isLoading,
}: {
  data: TransformedOccurrence;
  isDailyCareApp?: boolean;
  isLoading: boolean;
}) => {
  const {t} = useTranslation();

  return (
    <CardCollapse
      cardProps={{
        className: isDailyCareApp ? 'handle-card dailycareapp' : 'handle-card',
      }}
      isLoading={isLoading}
      defaultExpand={true}
      collapsableHeader={
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
          {data.patient ? (
            <CardHeader
              className="handle-patient"
              title={data.patient.name}
              avatar={
                <Avatar
                  sx={{
                    width: isDailyCareApp ? '36px' : '38px',
                    height: isDailyCareApp ? '36px' : '38px',
                    border:
                      data.patient?.socialResponses.length > 0
                        ? `1.5px solid ${data.patient?.socialResponses[0].foregroundColor}`
                        : 'none',
                  }}
                  src={data.patient.picture}
                />
              }
            />
          ) : (
            <Typography className="handle-card-header" noWrap>
              {t(translations.office.professional_caregiver.occurrences.information)}
            </Typography>
          )}
          <OccurrenceStatus status={data.status} />
        </Stack>
      }
    >
      <Stack gap="10px" paddingBottom="2px">
        <Stack flexDirection="row">
          <Stack width="50%">
            <Typography className="label">
              {t(translations.office.professional_caregiver.occurrences.date_hour)}
            </Typography>
            <Typography className="value">{`${moment(data.registeredAt).format('DD MMM YY')} ${t(translations.schedule_field.readable_periodicity.at_hour)} ${moment(data.registeredAt).format('HH:mm')}`}</Typography>
          </Stack>
          <Stack width="50%">
            <Typography className="label">
              {t(translations.daily_care_log.occurrences.local)}
            </Typography>
            <Typography className="value">{data.local || '-'}</Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography className="label">
            {t(translations.daily_care_log.occurrences.details)}
          </Typography>
          <Typography className="value">{data.details}</Typography>
        </Stack>
        <Stack flexDirection="row">
          {data.responsible && (
            <Stack width="50%">
              <Typography className="label">
                {t(translations.office.professional_caregiver.occurrences.responsible)}
              </Typography>
              <CardHeader
                className="handle-responsible"
                title={data.responsible.name}
                avatar={
                  <Avatar
                    sx={{
                      width: '28px',
                      height: '28px',
                    }}
                    src={data.responsible.picture}
                  />
                }
              />
            </Stack>
          )}
          {data.registeredBy && (
            <Stack width="50%">
              <Typography className="label">
                {t(translations.office.professional_caregiver.occurrences.registered_by)}
              </Typography>
              <CardHeader
                className="handle-registered-by"
                title={data.registeredBy.name}
                avatar={
                  <Avatar
                    sx={{
                      width: '28px',
                      height: '28px',
                    }}
                    src={data.registeredBy.picture}
                  />
                }
              />
            </Stack>
          )}
        </Stack>
      </Stack>
    </CardCollapse>
  );
};
